import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import * as api from '../api/inventory-lots';

export const useLotsPaginated = (params) =>
  useInfiniteQuery({
    queryKey: ['inventory-lots', 'paginated', params],
    queryFn: ({ pageParam = 1 }) =>
      api.getLotsPaginated({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: (prev) => prev,
  });

export const useLotsByProduct = (productUuid) =>
  useQuery({
    queryKey: ['inventory-lots', 'by-product', productUuid],
    queryFn: () => api.getLotsByProduct(productUuid),
    enabled: !!productUuid,
  });

export const useLot = (uuid) =>
  useQuery({
    queryKey: ['inventory-lots', uuid],
    queryFn: () => api.getLot(uuid),
    enabled: !!uuid,
  });

export const useExpiringLotsPaginated = (params) =>
  useInfiniteQuery({
    queryKey: ['inventory-lots', 'expiring', 'paginated', params],
    queryFn: ({ pageParam = 1 }) =>
      api.getExpiringLotsPaginated({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: (prev) => prev,
  });

export const useExpiredLotsPaginated = (params) =>
  useInfiniteQuery({
    queryKey: ['inventory-lots', 'expired', 'paginated', params],
    queryFn: ({ pageParam = 1 }) =>
      api.getExpiredLotsPaginated({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: (prev) => prev,
  });
